var map = {
	"./en.json": [
		8053,
		[]
	],
	"./en_criticalGoals.json": [
		693,
		[]
	],
	"./es.json": [
		1406,
		[
			211
		]
	],
	"./es_criticalGoals.json": [
		7874,
		[]
	],
	"./zh-hans.json": [
		6039,
		[
			398
		]
	],
	"./zh-hans_criticalGoals.json": [
		395,
		[]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7787;
module.exports = webpackAsyncContext;